import { colord as c, extend as i } from "colord";
import l from "colord/plugins/a11y";
i([l]);
const r = (t) => c(t), u = (t) => r(t).toHex(), x = (t) => r(t).toHex(), b = (t) => r(t).toRgb(), R = (t) => r(t).toRgb(), p = (t) => c(`rgb(${t[0]}, ${t[1]}, ${t[2]})`).toHex(), T = (t) => {
  const o = c(t).toRgb();
  return [o.r, o.g, o.b];
}, $ = (t) => t.map((o) => c(o).toRgb()).map(({ r: o, g: n, b: e }) => [o, n, e]), y = (t, o = 90) => {
  const n = 100 / (t.length - 1), e = t.map((a, g) => `${p(a)} ${g * n}%`).join(", ");
  return `linear-gradient(${o}deg, ${e})`;
}, C = (t) => {
  const o = getComputedStyle(document.documentElement), n = {};
  for (let e = 1; e <= 8; e++) {
    const s = o.getPropertyValue(`--plac-poi-${e}-default`).trim();
    n[s] = e;
  }
  return n[t] || null;
}, H = (t, o) => {
  const n = r(t), e = r(o);
  return n.contrast(e);
};
export {
  r as createColorObject,
  p as formatRGBColorToHex,
  y as generateLinearGradient,
  H as getContrastRatio,
  C as hexColorToEntityColorIndex,
  T as hexToRGB,
  b as hexToRgba,
  u as rgbaToHex,
  x as stringToHex,
  $ as stringToRGBArray,
  R as stringToRgba
};
//# sourceMappingURL=index.es521.js.map
